import { render, staticRenderFns } from "./dialog-table.vue?vue&type=template&id=2ab93d33&"
import script from "./dialog-table.vue?vue&type=script&lang=ts&"
export * from "./dialog-table.vue?vue&type=script&lang=ts&"
import style0 from "./dialog-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports